import Link from "next/link";
import { useState } from "react";
import { submitContact } from "../../lib/contactSubmit";
const ContactForm = ({ initialText = "" }) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [text, setText] = useState(initialText);
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    const contactForm = document.getElementById("contact-form");
    contactForm.noValidate = true;

    const isValid = contactForm.reportValidity();
    if (isValid) {
      sendEmail();
    }
    e.preventDefault();
  };

  // Only a confirmed send clears the form; on any failure the visitor keeps what they typed.
  const sendEmail = async () => {
    setLoading(true);
    setError(null);
    setSent(false);
    const result = await submitContact({ email, name, text });
    if (result.ok) {
      setEmail("");
      setName("");
      setText("");
      setAgreeToTerms(false);
      setSent(true);
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <form id="contact-form">
      <div className="flex space-x-7">
        <div className="mb-6 w-1/2">
          <label className="font-display text-jacarta-700 mb-1 block text-sm dark:text-white">
            Name<span className="text-red">*</span>
          </label>
          <input
            name="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="contact-form-input dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white"
            id="name"
            type="text"
            required
          />
        </div>

        <div className="mb-6 w-1/2">
          <label className="font-display text-jacarta-700 mb-1 block text-sm dark:text-white">
            Email<span className="text-red">*</span>
          </label>
          <input
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="contact-form-input dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white"
            id="email"
            type="email"
            required
          />
        </div>
      </div>

      <div className="mb-4">
        <label className="font-display text-jacarta-700 mb-1 block text-sm dark:text-white">
          Message<span className="text-red">*</span>
        </label>
        <textarea
          id="message"
          value={text}
          onChange={(e) => setText(e.target.value)}
          className="contact-form-input dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white"
          required
          name="message"
          rows="5"
        ></textarea>
      </div>

      <div className="mb-6 flex items-center space-x-2">
        <input
          type="checkbox"
          checked={agreeToTerms}
          onChange={(e) => setAgreeToTerms(e.target.checked)}
          id="contact-form-consent-input"
          name="agree-to-terms"
          className="checked:bg-accent dark:bg-jacarta-600 text-accent border-jacarta-200 focus:ring-accent/20 dark:border-jacarta-500 h-5 w-5 self-start rounded focus:ring-offset-0 cursor-pointer"
          required
        />
        <label className="dark:text-jacarta-200 text-sm">
          I agree to the{" "}
          <Link href="/terms" className="text-accent">
            Terms of Use
          </Link>{" "}
          and{" "}
          <Link href="/privacy" className="text-accent">
            Privacy Policy
          </Link>
        </label>
      </div>

      <button
        type="submit"
        onClick={handleSubmit}
        className="bg-accent shadow-accent-volume hover:bg-accent-dark rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
        id="contact-form-submit"
        disabled={loading}
      >
        {loading ? "Sending..." : "Submit"}
      </button>

      <div id="contact-form-notice" role="status" aria-live="polite">
        {error && (
          <p className="mt-4 rounded-lg border border-red bg-red/10 p-4 text-red dark:text-white">{error}</p>
        )}
        {sent && (
          <p className="mt-4 rounded-lg border border-green bg-green/10 p-4 text-green dark:text-white">
            Thanks! Your message is on its way, and a real person will read it.
          </p>
        )}
      </div>
    </form>
  );
};

export default ContactForm;
